import { DAY_IN_MILLISECONDS } from "../utils";

import type { PremiumDetectionResult } from "../utils";
import { safeLocalStorage } from "./storage";

const SOFTWALL_PREMIUM_USER_DETECTED_KEY =
  "BT_AM_PREMIUM_ADBLOCK_USER_DETECTED";
const SOFTWALL_PREMIUM_USER_DETECTION_DATE_KEY =
  "BT_AM_PREMIUM_ADBLOCK_USER_DETECTION_DATE";

const onInvalidOrInexistentDetectionData = () => {
  safeLocalStorage.remove(SOFTWALL_PREMIUM_USER_DETECTED_KEY);
  safeLocalStorage.remove(SOFTWALL_PREMIUM_USER_DETECTION_DATE_KEY);
  throw new Error("invalid or inexistent premium detection data");
};

export const getPremiumDetectionData = () => {
  const detectionUTCString = safeLocalStorage.get(
    SOFTWALL_PREMIUM_USER_DETECTION_DATE_KEY,
  );

  const detectionData = safeLocalStorage.get(
    SOFTWALL_PREMIUM_USER_DETECTED_KEY,
  );

  try {
    if (!detectionUTCString || !detectionData) {
      onInvalidOrInexistentDetectionData();
    }

    const detectionDate = new Date(detectionUTCString);
    if (Date.now() - detectionDate.getTime() > DAY_IN_MILLISECONDS) {
      onInvalidOrInexistentDetectionData();
    }

    const parsed = JSON.parse(detectionData);
    if (
      typeof parsed !== "object" ||
      parsed === null ||
      !("isPremium" in parsed) ||
      !("extensionInfo" in parsed)
    ) {
      onInvalidOrInexistentDetectionData();
    }

    return { isPremium: parsed.isPremium, extensionInfo: parsed.extensionInfo };
  } catch {
    return null;
  }
};

export const savePremiumDetection = (
  detectionResult: PremiumDetectionResult,
) => {
  safeLocalStorage.set(
    SOFTWALL_PREMIUM_USER_DETECTED_KEY,
    JSON.stringify(detectionResult),
  );
  safeLocalStorage.set(
    SOFTWALL_PREMIUM_USER_DETECTION_DATE_KEY,
    new Date().toUTCString(),
  );
};
